import { type ReactElement, useCallback, useMemo } from 'react'
import { Select } from '@mantine/core'
import { TSegmentedControl, type TSegmentedControlOption } from './TSegmentedControl'

type Props<T extends string> = {
  options: TSegmentedControlOption<T>[]
  value: T
  onChange: (value: T) => void
}

export const EntityTabs = <T extends string>({ options, value, onChange }: Props<T>): ReactElement => {
  const selectOptions = useMemo(
    () => options.map((option) => ({ label: option.label, value: option.value })),
    [options]
  )

  const handleSelectChange = useCallback(
    (nextValue: string | null): void => {
      const option = options.find(({ value: optionValue }) => optionValue === nextValue)
      if (option) onChange(option.value)
    },
    [onChange, options]
  )

  return (
    <>
      <TSegmentedControl visibleFrom='sm' options={options} value={value} onChange={onChange} />
      <Select
        aria-label='Select section'
        data={selectOptions}
        hiddenFrom='sm'
        value={value}
        onChange={handleSelectChange}
      />
    </>
  )
}
